import { render, staticRenderFns } from "./IconArrowLeft.vue?vue&type=template&id=24eab2db"
import script from "./IconArrowLeft.vue?vue&type=script&lang=js"
export * from "./IconArrowLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports